<template>
  <vs-popup class="add-new-my-skill" id="popup" :title="isCreateMode ? 'ADD SKILL' : 'UPDATE SKILL'"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-my-skill-popup" @submit.prevent="handleSubmit(onClickCreateUpdate)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="skill_id" name="skill_id" rules="required" v-slot="{ errors }">
                <small class="label">Skill</small>
                <v-select :clearable="false" placeholder="" v-model="form.skill_id"
                  :options="skill_list" :dir="$vs.rtl ? 'rtl' : 'ltr'" label="name"
                  :reduce="option => option.id">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="proficiency_level" name="proficiency_level" rules="required" v-slot="{ errors }">
                <small class="label">Proficiency Level</small>
                <v-select :clearable="false" placeholder="" v-model="form.proficiency_level"
                  :options="['Beginner', 'Intermediate', 'Advanced', 'Expert']" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="years_of_experience" name="years_of_experience" rules=""
                v-slot="{ errors }">
                <small class="label">Years of Experience</small>
                <vs-input v-model="form.years_of_experience" name="years_of_experience" class="w-full" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="last_used_date" name="last_used_date" rules="" v-slot="{ errors }">
                <small class="label">Last Used Date</small>
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" v-model="form.last_used_date" placeholder="Choose Date"
                  class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          
          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="notes" name="notes" rules="" v-slot="{ errors }">
                <small class="label">Notes</small>
                <vs-textarea class="mb-0" v-model="form.notes" height="150px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-ccp-items-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const SkillQualificationRepository = RepositoryFactory.get('skills');
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      skill_id: '',
      proficiency_level: '',
      years_of_experience: '',
      last_used_date: '',
      notes: ''
    },
    isCreateMode: true,
    skill_list: [],
  }
}

export default {
  name: 'AddNewMySkillPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        await this.fetchSkillList()
        if (!!id) {
          this.id = id
          this.isCreateMode = false
          await this.fetchMySkillDetails()
        } else {
          this.isCreateMode = true
        }
      } catch (error) {

      }
    },
    async fetchMySkillDetails() {
      await this.$vs.loading({
        container: '#create-my-skill-popup',
        scale: 0.45
      })
      try {
        const { data } = (await SkillQualificationRepository.getMySkill(this.id)).data
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-my-skill-popup > .con-vs-loading')
    },
    async fetchSkillList() {
      await this.$vs.loading({
        container: '#create-my-skill-popup',
        scale: 0.45
      })
      try {
        const { data } = (await SkillQualificationRepository.getListOfStaffSkillsDropdown()).data
        this.skill_list = data.filter(x => !!x.is_active)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-my-skill-popup > .con-vs-loading')
    },
    async onClickCreateUpdate() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-my-skill-popup',
        scale: 0.45
      })
      try {
        if (this.isCreateMode) {
          await SkillQualificationRepository.createMySkills(this.$store.getters.currentUserId, this.form);
          this.showSuccessMessage('Skill added!');
        } else {
          await SkillQualificationRepository.updateMySkills(this.id, this.form);
          this.showSuccessMessage('Skill updated!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-my-skill-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-my-skill-popup > .con-vs-loading')
    },
  },
  components: {
    'v-select': vSelect,
    flatPickr,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-new-my-skill>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}
</style>
